import React, { useState } from 'react';
import { Handle, Position } from 'reactflow';
import { Bell, Settings } from 'lucide-react';

const NotificationNode = ({ data, selected }) => {
  const [showConfig, setShowConfig] = useState(false);
  
  return (
    <>
      <div className={`px-4 py-2 shadow-md rounded-lg bg-red-500 text-white border-2 ${
        selected ? 'border-red-300' : 'border-red-600'
      }`}>
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-2">
            <Bell className="h-4 w-4" />
            <div className="text-sm font-medium">{data.label}</div>
          </div>
          <button
            onClick={() => setShowConfig(true)}
            className="p-1 hover:bg-red-600 rounded"
          >
            <Settings className="h-3 w-3" />
          </button>
        </div>
        
        {data.config?.type && (
          <div className="text-xs mt-1 opacity-90">
            {data.config.type}: {data.config.recipient}
          </div>
        )}
        
        <Handle
          type="target"
          position={Position.Top}
          style={{
            background: '#ef4444',
            border: '2px solid #dc2626',
          }}
        />
        <Handle
          type="source"
          position={Position.Bottom}
          style={{
            background: '#ef4444',
            border: '2px solid #dc2626',
          }}
        />
      </div>

      {showConfig && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white rounded-lg p-6 w-96">
            <h3 className="text-lg font-semibold mb-4">Configure Notification Node</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700">Notification Type</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>Email</option>
                  <option>SMS</option>
                  <option>Slack</option>
                  <option>Webhook</option>
                  <option>Push Notification</option>
                  <option>In-App Alert</option>
                </select>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Recipients</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="email@example.com, +1234567890"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Subject/Title</label>
                <input 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Notification subject..."
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Message</label>
                <textarea 
                  className="mt-1 w-full border rounded-lg px-3 py-2"
                  placeholder="Notification message (use {{variables}})..."
                  rows="4"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700">Priority</label>
                <select className="mt-1 w-full border rounded-lg px-3 py-2">
                  <option>Low</option>
                  <option>Normal</option>
                  <option>High</option>
                  <option>Urgent</option>
                </select>
              </div>
            </div>
            <div className="flex justify-end space-x-2 mt-6">
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 border rounded-lg hover:bg-gray-50"
              >
                Cancel
              </button>
              <button
                onClick={() => setShowConfig(false)}
                className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default NotificationNode;